import { render, staticRenderFns } from "./order_refund_step2_list.vue?vue&type=template&id=7976c8cc&scoped=true&"
import script from "./order_refund_step2_list.vue?vue&type=script&lang=js&"
export * from "./order_refund_step2_list.vue?vue&type=script&lang=js&"
import style0 from "./order_refund_step2_list.vue?vue&type=style&index=0&id=7976c8cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7976c8cc",
  null
  
)

export default component.exports